export const ButtonLoader = () => {
  return <div className="spinner-loader"></div>;
};
